import { API_ENDPOINTS } from "../constants/apiconfig/apiconfig";

// apiconfig.js lists only the auth, dashboard and management URLs, so the rest
// of the portal URLs are derived here from the same BASE_URL. That keeps
// apiconfig.js untouched; if a key is ever added there, it takes priority.
const root = `${API_ENDPOINTS.BASE_URL}ciodsconnect/`;
const pick = (key, path) => API_ENDPOINTS[key] || `${root}${path}`;

export const CONNECT_ENDPOINTS = {
  // Authentication
  register: pick("CIODSCONNECT_REGISTER", "auth/register/"),
  login: pick("CIODSCONNECT_LOGIN", "auth/login/"),
  adminLogin: pick("CIODSCONNECT_ADMIN_LOGIN", "auth/admin-login/"),
  refresh: pick("CIODSCONNECT_REFRESH", "auth/refresh/"),

  // Dashboards
  dashboard: pick("CIODSCONNECT_DASHBOARD", "dashboard/"),
  organisationDashboard: pick("CIODSCONNECT_ORGANISATION_DASHBOARD", "organisation-dashboard/"),
  organisationPublications: pick("CIODSCONNECT_ORGANISATION_PUBLICATIONS", "organisation-publications/"),
  facultyResearchSummary: pick("CIODSCONNECT_FACULTY_RESEARCH_SUMMARY", "faculty-research-summary/"),

  // People & teams (management analytics)
  employees: pick("CIODSCONNECT_MANAGEMENT_EMPLOYEES", "management/employees/"),
  teams: pick("CIODSCONNECT_MANAGEMENT_TEAMS", "management/teams/"),
  teamManagement: pick("CIODSCONNECT_TEAM_MANAGEMENT", "management/team-management/"),
  managementEmployees: pick("CIODSCONNECT_MANAGEMENT_EMPLOYEES", "management/employees/"),
  managementRecords: pick("CIODSCONNECT_MANAGEMENT_RECORDS", "management/records/"),

  // Records
  tasks: pick("CIODSCONNECT_TASKS", "tasks/"),
  publications: pick("CIODSCONNECT_PUBLICATIONS", "publications/"),
  funding: pick("CIODSCONNECT_FUNDING", "funding/"),
  patents: pick("CIODSCONNECT_PATENTS", "patents/"),
  achievements: pick("CIODSCONNECT_ACHIEVEMENTS", "achievements/"),
  deadlines: pick("CIODSCONNECT_DEADLINES", "deadlines/"),
  activity: pick("CIODSCONNECT_ACTIVITY", "activity/"),
  notifications: pick("CIODSCONNECT_NOTIFICATIONS", "notifications/"),
  notificationSend: pick("CIODSCONNECT_NOTIFICATION_SEND", "notifications/send/"),
  // The simple team list used by the record forms (not the analytics above).
  teamList: pick("CIODSCONNECT_TEAMS", "teams/"),
};
